import httpClient from '@xto10x/core/lib/httpClient';
import config from 'utils/config';

const integrationApi = {
  getIntegrations: () =>
    httpClient.get(
      `${config.blitzApiUrl}/v1/integration`,
      null,
      {},
      null,
      window.location.hostname.startsWith('cues')
    ),

  updateIntegration: requestBody =>
    httpClient.put(
      `${config.blitzApiUrl}/v1/integration`,
      requestBody,
      null,
      {},
      window.location.hostname.startsWith('cues')
    )
};

export default integrationApi;
